import { React, useEffect } from 'react';
import "../CSS/production.css";
import ProdDescr from '../components/ProductionPage/ProdDescr';
import ProdAdv from '../components/ProductionPage/ProdAdv';
import ProdCases from '../components/ProductionPage/ProdCases';

export default function Production() {
  useEffect(() => {
    window.scrollTo(0, 0); // Прокрутка страницы в начало при монтировании компонента
  }, []);
  
  return (
    <div>
      <ProdDescr />
      <ProdAdv />
      <ProdCases />
    </div>
  )
}
